<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Editar Notificación" />

    <CreateNotification />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue"; 
import CreateNotification from "@/components/Pages/Admin/Notifications/view.vue";

export default defineComponent({
  name: "CreateNotificationPage",
  components: {
    PageTitle,
    CreateNotification,
  },
});
</script>
